<script setup lang="ts">
  import { ref, watch } from "vue";

  defineOptions({ inheritAttrs: false });
  const { closeOnOutsideClick = true, isOpen } = defineProps<{
    isOpen: boolean;
    closeOnOutsideClick?: boolean;
  }>();
  const emit = defineEmits<{ "close": [value: void] }>();

  const isOverlayVisible = ref(false);
  const isModalVisible = ref(false);

  const handleClose = () => {
    isModalVisible.value = false;
    emit("close");
  };

  const handleClickOverlay = () => {
    if (closeOnOutsideClick) {
      handleClose();
    }
  };

  watch(
    () => isOpen,
    (value) => {
      if (value) {
        isOverlayVisible.value = true;

        setTimeout(() => (isModalVisible.value = true));
      } else {
        isModalVisible.value = false;
      }
    },
  );
</script>

<template>
  <Teleport to="body">
    <div v-if="isOverlayVisible" class="modal-overlay" @click="handleClickOverlay">
      <Transition @after-leave="isOverlayVisible = false">
        <div v-if="isModalVisible" class="modal-content" @click.stop :data-testid="$attrs['data-testid']">
          <slot />
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--sf-base-background-modal);
    z-index: 1000;
  }

  .modal-content {
    background: var(--sf-base-background-white);
    border-radius: 16px;
    box-shadow: var(--sf-shadow-bot-m);
  }

  /* Анимации появления */
  .v-enter-active {
    animation: modal-in 200ms cubic-bezier(0.45, 1.45, 0.8, 1);
  }

  .v-leave-active {
    animation: modal-out 100ms ease-in;
  }

  @keyframes modal-in {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes modal-out {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0.8);
    }
  }
</style>
